<div class="custom-select" formGroup="childForm" onsubmit="return false">
  <mat-form-field appearance="outline">
    <mat-label [ngClass]="{ 'custom-select__fix-label-required': childForm.get(controlName).invalid && requiredLabel }">
      {{ label | i18nextEager }} {{ required ? '*' : '' }}</mat-label
    >
    <mat-select
      #matSelect
      disableOptionCentering
      [formControlName]="controlName"
      [(value)]="defaultValue"
      [disabled]="disabled"
      [panelClass]="panelClass"
      [multiple]="multiple"
      (valueChange)="onSelect($event)"
      (openedChange)="toogleOpen($event)"
    >
      <div *ngIf="searchBar" class="custom-select-search__container">
        <ng-container *ngIf="!minLength">
          <ng-container *ngIf="numeric; else textNoMinLength">
            <input
              numeric
              matInput
              class="custom-select-search__input"
              [attr.maxlength]="maxLength"
              (input)="handleSearch()"
              (keydown)="$event.stopPropagation()"
              #searcher
            />
          </ng-container>
          <ng-template #textNoMinLength>
            <input
              matInput
              class="custom-select-search__input"
              [attr.maxlength]="maxLength"
              (input)="handleSearch()"
              (keydown)="$event.stopPropagation()"
              #searcher
            />
          </ng-template>

          <button class="custom-select-search__suffix-icon custom-select-search__suffix-icon--not-cursor ">
            <img src="/assets/icons/search.svg" alt="" />
          </button>
        </ng-container>
        <ng-container *ngIf="minLength">
          <ng-container *ngIf="numeric; else textMinLength">
            <input
              matInput
              numeric
              class="custom-select-search__input"
              [attr.maxlength]="maxLength"
              (input)="handleChange($event)"
              (keydown)="$event.stopPropagation()"
              #searcher
            />
          </ng-container>
          <ng-template #textMinLength>
            <input
              matInput
              class="custom-select-search__input"
              [attr.maxlength]="maxLength"
              (input)="handleChange($event)"
              (keydown)="$event.stopPropagation()"
              #searcher
            />
          </ng-template>

          <button
            class="custom-select-search__suffix-icon"
            [disabled]="inputValue.replace(whiteSpaceRegex, '').length < minLength"
            (click)="handleSearch()"
          >
            <img src="/assets/icons/search.svg" alt="" />
          </button>
        </ng-container>
      </div>
      <app-loading *ngIf="isLoading" [onlyIcon]="true"></app-loading>
      <div #options *ngIf="!isLoading" class="options">
        <mat-option
          #allSelected
          *ngIf="
            selectAllOption &&
            optionsFiltered?.length > 1 &&
            ((searchBar && !searcher?.nativeElement?.value) || (searchBar && !search && minLength) || !searchBar)
          "
          value="allOptions"
          (click)="selectAll()"
        >
          {{ 'COMMONS.SELECT_ALL' | i18nextEager }}
        </mat-option>
        <mat-option *ngFor="let item of optionsFiltered" [value]="item?.value" (click)="selectOption(item?.value)">
          {{ item?.label }}</mat-option
        >
        <div *ngIf="showMore" class="custom-select-search__more" (click)="handleMore()">
          {{ 'COMMONS.CHARGE_MORE' | i18nextEager }}
        </div>
      </div>
    </mat-select>
    <img
      *ngIf="!disabled"
      matSuffix
      src="/assets/icons/chevron-enabled.svg"
      class="suffix-icon"
      alt=""
      [ngClass]="{ 'suffix-icon--open': open }"
    />
    <img matSuffix *ngIf="disabled" src="/assets/icons/chevron-disabled.svg" class="suffix-icon--disabled" alt="" />
  </mat-form-field>
</div>
